export default __webpack_public_path__ + "static/media/Dishath.d990df3c.png";